import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { Validator } from "../../snippets/Validator";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";

export class Vehicle extends CRUDEntity {
    #validationFields = [
        'driver',
        'status',
        'model',
        'class',
        'plate',
    ];

    constructor(id=null) {
        Object.assign(Vehicle.prototype, FormActions);
        Object.assign(Vehicle.prototype, EntityModalForm);
        Object.assign(Vehicle.prototype, HasAttachments);

        super();
        this.entityClass = 'vehicle';
        this.urlRoot = '/vehicles-management/vehicle';
        this.sectionRootUrl = '/vehicles-management';
        this.id = id;

        this.setAttachmentCallbackDelete();
        this.setAttachmentCallbackPreview();
        Vehicle.prototype.delegatedListnersForButtons = function(type, entityClass) {
            daterangepicker.setPicker($('input#inspection'), 'MM/DD/YYYY');
            daterangepicker.setPicker($('input#registration'), 'MM/DD/YYYY');

            $('input#inspection').val('');
            $('input#registration').val('');

            const validateCb = () => {
                if(this.validationForm(type))
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',false)
                else
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',true)
            }
            for(let field of this.#validationFields){
                $(`#${type}-${entityClass} [name=${field}]`).on('input',validateCb)
            }
            if(type == 'edit')
                validateCb()
            $(`#${type}-${entityClass} button#${type}`).off();
            $(`#${type}-${entityClass} button#${type}`).on('click', () => {
                if(this.validationForm(type,true)){
                    if (type == 'create')
                        this.create(()=>setTimeout(() => window.location.reload(), 500));
                    if (type == 'edit')
                        this.update(()=>setTimeout(() => window.location.reload(), 500));
                }
            });
        }
    }

    validationForm(type, isSelectErrorFields=false){
        const formId = `${type}-${this.entityClass}`;
        const data = this.collectDataInForm(formId);
        const validator = new Validator({
            'status': ['required'],
            'model': ['required'],
            'class': ['required'],
            'plate': ['required'],
        });
        let validateFlag = true;
        this.#validationFields.forEach(element => {
            if (validator.validate(element, data[element])) {
                if(isSelectErrorFields)
                    $(`#${formId} [name="${element}"]`).attr('style','');
            }else{
                validateFlag = false;
                if(isSelectErrorFields)
                    $(`#${formId} [name="${element}"]`).attr('style','border:2px solid #DB3A57 !important;');
            }
        });
        console.log(validateFlag);
        return validateFlag;
    }
}
